import { render, staticRenderFns } from "./SetupNotifications.vue?vue&type=template&id=b6c5d748&scoped=true&"
import script from "./SetupNotifications.vue?vue&type=script&lang=js&"
export * from "./SetupNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SetupNotifications.vue?vue&type=style&index=0&id=b6c5d748&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c5d748",
  null
  
)

export default component.exports